import { SidebarLink } from "@tngtech/tng-ui";
import React from "react";
import { useLocation } from "react-router";

export const InternalLink = ({
  title,
  pathname,
  icon,
  onClick,
}: {
  title: string;
  pathname: string;
  icon: React.ComponentType;
  onClick?: () => void;
}) => {
  const location = useLocation();

  const selected = location.pathname === pathname;
  return (
    <SidebarLink
      href={pathname}
      title={title}
      icon={icon}
      selected={selected}
      onClick={onClick}
    />
  );
};
